module.exports = __webpack_public_path__ + "img/no-comment.0cf7c0cf.svg";